import { render } from "./KBForm.vue?vue&type=template&id=238249a7"
import script from "./KBForm.vue?vue&type=script&lang=js"
export * from "./KBForm.vue?vue&type=script&lang=js"

import exportComponent from "E:\\kbruland\\Handweaving-3.0\\hw-vue3-website\\hw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__